// extracted by mini-css-extract-plugin
module.exports = {"list":"MarketplacesList-module--list--a74366","item":"MarketplacesList-module--item--fe689c","link":"MarketplacesList-module--link--334c58"};